<script>
import TwProgressBar from '@/components/generic/tw-progress-bar.vue'
import TwBadge from '@/components/generic/tw-badge.vue'
import { UserGroupIcon } from '@heroicons/vue/24/outline'
import { useFundraiserStore } from '@/stores/fundraiser.js'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'


export default {
  name: "FundraiserPageCompact",
  components: { TwBadge, TwProgressBar, UserGroupIcon },
  props: {
    fundraiserPage: {
      type:Object,
      required:true
    }
  },
  computed: {
    fundraiser() {
      return useFundraiserPublicStore().getItemById(this.fundraiserPage.fundraiser_id)
    },
    raisedFormatted() {
      return this.$filters.formatCurrency(this.fundraiserPage.cached?.raised, this.fundraiserPage.currency)
    },
    goalFormatted() {
      return this.$filters.formatCurrency(this.fundraiserPage.goal, this.fundraiserPage.currency)
    }
  }
}
</script>

<template>
  <router-link class="flex gap-3 border-gray-200 border rounded-2xl p-4 hover:bg-white" :to="{name: 'FundraiserPagePublicPage', params: { fundraiserPageId: fundraiserPage.id, slug: fundraiserPage.slug }}">
    <div class="min-h-12 min-w-12">
      <img v-if="fundraiserPage.cached.owner_avatar_url_small" class="size-12 rounded-full object-cover" :src="fundraiserPage.cached.owner_avatar_url_small" :alt="fundraiserPage.cached.owner_name">
      <span v-else class="inline-flex size-12 items-center justify-center rounded-full bg-gray-100">
        <span v-if="fundraiserPage.cached.owner_initials" class="text-1xl font-normal leading-none text-gray-500">{{ fundraiserPage.cached.owner_initials }} </span>
      </span>
    </div>
    <div class="flex flex-col gap-1 grow mt-1">
      <h6 v-if="fundraiser && fundraiser.settings && fundraiser.settings.lock_title && fundraiserPage.cached">
        {{ fundraiserPage.cached.owner_name }}
      </h6>
      <h6 v-else>
        {{ fundraiserPage.title }}
      </h6>
      <div class="text-xs text-gray-600">
        <span v-if="fundraiserPage.cached">{{ raisedFormatted }}</span> raised of {{ goalFormatted }} goal
      </div>
      <tw-progress-bar v-if="fundraiserPage.cached" class="mt-3" :progress="fundraiserPage.cached.percentage_raised" />
      <span>
        <tw-badge v-if="fundraiserPage.cached && fundraiserPage.cached.team_name" size="xs" class="my-1 bg-gray-100">
          <UserGroupIcon class="h-4 w-4" /> <router-link v-if="fundraiserPage.belongs_to_team_id" :to="{name: 'FundraiserTeamPublicPage', params: { fundraiserId: fundraiserPage.fundraiser_id, teamId: fundraiserPage.belongs_to_team_id }}" class="ml-1 font-semibold hover:underline">
            {{ fundraiserPage.cached.team_name }}
          </router-link>
          <span v-else class="font-semibold">
            {{ fundraiserPage.cached.team_name }}
          </span>
        </tw-badge>
      </span>
      <!-- <router-link class="underline text-gray-600 text-xs" :to="{name: 'FundraiserPagePublicPage', params: { fundraiserPageId: fundraiserPage.id, slug: fundraiserPage.slug }}">
        View {{ fundraiserPage.cached.owner_name }}'s page
      </router-link> -->
    </div>
  </router-link>
</template>

<style scoped>

</style>
